import shippingMessages, { maybeGetDisplayName } from '../shipping/shippingMessages';
import { getFormattedAmountWithCurrency } from '../utils/numberUtils';



export const getShippingCostDisplay = (cost, intl, currencyCode) => (
    parseFloat(cost) === 0
        ? intl.formatMessage(shippingMessages.free)
        : getFormattedAmountWithCurrency(intl, cost, currencyCode, true)
);


export const getShippingOptionText = (intl, shippingMethod) => {
    if (!shippingMethod) {
        return intl.formatMessage(shippingMessages.noneSelected);
    }
    const {
        cost, carrier, methodName, displayName, currencyCode
    } = shippingMethod.toJS();

    const displayCost = getShippingCostDisplay(cost, intl, currencyCode);
    const maybeDisplayName = maybeGetDisplayName(carrier, methodName);
    const displayText = maybeDisplayName ? `${intl.formatMessage(maybeDisplayName.toJS())}` : `${displayName}`;

    return `${displayCost} ${displayText}`;
};


export default {
    getShippingOptionText
};
